// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"116":"dd527644","817":"d9245cd3","906":"5052b8e6"}[chunkId] + ".css";
};